// fetchGifts.js
'use strict';
import parseLinkHeader from 'parse-link-header';

import fetch from '../resource/customFetch.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import objectifyArrayById from '../resource/objectifyArrayById.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import handleFetchError from '../resource/handleFetchError.js';
import getMeData from '../selector/getMeData.js';
import addGifts from '../action/addGifts.js';
import {
  ADD_LIST_ITEMS,
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

/**
 * Fetch gifts
 * @kind action
 * @param {string} { category } - gift category.
 * @param {number} { [page = 1] } - page number.
 * @param {number} { [limit = 10] } - page size.
 * @return {Promise} Action promise.
 */
const fetchGifts =
  ({ category, page = 1, limit = 10 }) =>
  async (dispatch, getState) => {
    const token = getMeData(getState(), 'token');

    const fetchOptions = {
      headers: {
        ...getHeaders(),
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    };

    const selectPath = ['gift', 'item', category, page];
    const listSelectPath = ['gift', 'item', category];
    const url = getResourceUrl({ endpoint: '/gifts' });
    url.searchParams.append('limit', limit);
    url.searchParams.append('page', page);
    url.searchParams.append('category', category);

    dispatch({ type: SET_NETWORKING_FETCHING, payload: { selectPath } });

    try {
      let response = await fetch(url.href, fetchOptions);

      if (!response.ok) {
        response = await handleFetchError({
          response,
          dispatch,
          getState,
          fetchOptions,
          fetchUrl: url,
        });
      }

      const totalCount = parseInt(response.headers.get('x-total-count'), 10);
      const links = parseLinkHeader(response.headers.get('Link'));
      const nextPage = links && links.next && parseInt(links.next.page, 10);
      const lastPage = links && links.last && parseInt(links.last.page, 10);

      const data = await response.json();
      const gifts = objectifyArrayById({ array: data });
      const itemIds = Object.keys(gifts);

      dispatch({
        type: ADD_LIST_ITEMS,
        payload: {
          selectPath: listSelectPath,
          itemIds,
          totalCount,
          nextPage,
          lastPage,
        },
      });

      dispatch(addGifts({ gifts }));

      return dispatch({
        type: SET_NETWORKING_SUCCESS,
        payload: { selectPath },
      });
    } catch (error) {
      return dispatch({
        type: SET_NETWORKING_ERROR,
        payload: { selectPath, error },
      });
    }
  };

export default fetchGifts;
